import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";

const NovaPayBalancesPage = ({ user }) => {
    const [balances, setBalances] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        // if (user?.role !== "director") return;

        const loadBalances = async () => {
            try {
                const res = await fetch("/api/novapay/balances");
                if (!res.ok) throw new Error("Access denied or server error");
                const data = await res.json();
                setBalances(data);
            } catch (err) {
                setError("Не вдалося отримати залишки");
            } finally {
                setLoading(false);
            }
        };

        loadBalances();
    }, [user]);

    // if (user?.role !== "director") return <p>⛔ Доступ лише для директора</p>;

    if (loading) return <Spinner animation="border" />;

    if (error) return <p className="text-danger">{error}</p>;

    return (
        <div className="p-4">
            <h3>Залишки на рахунках NovaPay</h3>
            <ul className="list-group">
                {balances.map((b, i) => (
                    <li key={i} className="list-group-item d-flex justify-content-between align-items-center">
                        {b.name}
                        {b.error ? (
                            <span className="text-danger">❌ Помилка</span>
                        ) : (
                            <span>
                                <strong>{b.balance} грн</strong>
                            </span>
                        )}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default NovaPayBalancesPage;
